module.exports = __webpack_public_path__ + "static/media/asset_quiz_intro.cee6ab34.svg";